import { theme } from '../theme.js';
import { NavBar } from './NavBar.js';

interface Props {
  children: React.ReactNode;
  /** Hide the bottom nav (detail screens) */
  noNav?: boolean;
  /** Wider max-width for admin screens */
  wide?: boolean;
}

export function PageShell({ children, noNav, wide }: Props) {
  return (
    <div style={{
      height: '100dvh', display: 'flex', flexDirection: 'column',
      background: theme.bg, maxWidth: wide ? 960 : 480, margin: '0 auto', width: '100%',
      position: 'relative',
    }}>
      <div style={{ flex: 1, overflowY: 'auto', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        {children}
      </div>
      {!noNav && <NavBar />}
    </div>
  );
}
